import React from "react";

export default function NationellaListMark() {
  return <div style={{ margin: "0 20px", fontSize: 20 }}>N</div>;
}
